export default {
  // navigationBarTitleText: '智能导服',
};
